"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = htmlToEmbedData;
exports.htmlNodeToData = exports.htmlNodesArrayToData = exports.getAttributesData = void 0;

var _embed = require("../constants/embed");

var _parseHTML = _interopRequireDefault(require("./parseHTML"));

var getAttributesData = function getAttributesData(attributes) {
  var attrs = [];

  for (var i = 0; i < attributes.length; i++) {
    var attr = attributes[i];
    attrs.push({
      key: attr.nodeName,
      value: attr.nodeValue ? attr.nodeValue : null
    });
  }

  return attrs;
};

exports.getAttributesData = getAttributesData;

var htmlNodesArrayToData = function htmlNodesArrayToData(childNodes, ignoreScripts) {
  var children = [];

  for (var i = 0; i < childNodes.length; i++) {
    var data = htmlNodeToData(childNodes[i], ignoreScripts); // eslint-disable-line no-use-before-define

    if (data) {
      children.push(data);
    }
  }

  return children;
};

exports.htmlNodesArrayToData = htmlNodesArrayToData;

var htmlNodeToData = function htmlNodeToData(node, ignoreScripts) {
  var data = {};

  switch (node.nodeType) {
    case _embed.nodeTypes.ELEMENT:
      {
        var tagName = node.tagName.toLowerCase();

        if (tagName === 'script' && ignoreScripts || _embed.ignoreTags.includes(tagName)) {
          return null;
        }

        data.tag = tagName;
        data.attributes = getAttributesData(node.attributes);
        data.children = htmlNodesArrayToData(node.childNodes, ignoreScripts);
        return data;
      }

    case _embed.nodeTypes.TEXT:
      data.tag = 'text';
      data.content = node.textContent;
      return data;

    default:
      return null;
  }
};

exports.htmlNodeToData = htmlNodeToData;

function htmlToEmbedData(html) {
  var ignoreScripts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!html) {
    return null;
  }

  var body = (0, _parseHTML.default)(html.replace(/\r?\n|\r/g, ''));

  if (body === null) {
    return null;
  }

  return htmlNodesArrayToData(body.childNodes, ignoreScripts);
}